module.exports = __webpack_public_path__ + "img/004-storyboard.69738555.svg";